// Main entry point for the client-side application
import { Crepe } from '@milkdown/crepe';

// Import Crepe CSS - Vite will handle these properly
import '@milkdown/crepe/theme/common/style.css';
import '@milkdown/crepe/theme/frame.css';

import { DocumentAccelerationApp } from './app.js';

console.log('Jet Stream: Client bundle loaded');

// Milkdown Editor Manager using Crepe
class MilkdownEditorManager {
    constructor() {
        this.crepe = null;
        this.currentContent = '';
        this.onChange = null;
        this.container = null;
    }

    async initialize(container, content = '', onChange = null) {
        this.onChange = onChange;
        this.currentContent = content;
        this.container = container;

        try {
            console.log('Initializing Milkdown Crepe editor');
            console.log('Container:', container);
            console.log('Initial content length:', content ? content.length : 0);

            // Create Crepe instance
            this.crepe = new Crepe({
                root: container,
                defaultValue: content || '',
                onChange: (getMarkdown) => {
                    const markdown = getMarkdown();
                    this.currentContent = markdown;
                    if (this.onChange) {
                        this.onChange(markdown);
                    }
                    console.log('Milkdown change:', this.currentContent);
                },
                onStatusChange: (status) => {
                    console.log('Milkdown status change:', status);
                },
            });

            console.log('Crepe instance created:', this.crepe);

            // Create the editor
            await this.crepe.create();

            console.log('Milkdown Crepe editor initialized successfully');
            return this.crepe;
        } catch (error) {
            console.error('Failed to initialize Milkdown Crepe:', error);
            throw error;
        }
    }

    setContent(markdown) {
        if (!this.crepe) {
            console.warn('Editor not initialized yet');
            return;
        }

        try {
            // Crepe doesn't have a direct setContent method
            // We need to destroy and recreate with new content
            this.destroy();
            this.initialize(this.container, markdown, this.onChange);
        } catch (error) {
            console.error('Error setting Milkdown content:', error);
        }
    }

    getContent() {
        if (this.crepe && this.crepe.getMarkdown) {
            return this.crepe.getMarkdown();
        }
        return this.currentContent;
    }

    destroy() {
        if (this.crepe) {
            try {
                this.crepe.destroy();
            } catch (error) {
                console.warn('Error destroying Crepe editor:', error);
            }
            this.crepe = null;
        }
    }

    setReadOnly(readOnly) {
        if (this.crepe) {
            // Crepe handles read-only through configuration
            // For now, we'll just log it - may need to recreate editor
            console.log('Read-only mode:', readOnly);
            // Note: Crepe doesn't have a direct setReadOnly method
            // Would need to recreate the editor with readOnly: true in config
        }
    }
}

// Export for use in app
export { MilkdownEditorManager };

// Initialize app when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.app = new DocumentAccelerationApp();
    });
} else {
    window.app = new DocumentAccelerationApp();
}